let bqjUrl = ""; //这里是一个默认的url，可以没有
let svipUrl =""; //
switch (process.env.NODE_ENV) {
    case 'pre':
        bqjUrl = "http://ganganback.bqj.cn" // 测试环境
        svipUrl = "http://ganganback.bqj.cn"
        break
    case 'test':
        bqjUrl = "http://ganganback.bqj.cn" // 测试环境
        svipUrl = "http://ganganback.bqj.cn"
        break
    case 'production':
        bqjUrl = "https://back.gsbqfw.com" //生产环境
        svipUrl =  "https://back.gsbqfw.com"
        // bqjUrl = "https://ganganback.bqj.cn" // 测试环境
        // svipUrl = "https://ganganback.bqj.cn"
        break

    default:
        bqjUrl = "http://localhost:17888" // 测试环境
        svipUrl = "http://localhost:17888"
        break
}

export{
    bqjUrl,
    svipUrl
};